import { c as _c } from "react/compiler-runtime";
import type { Data } from '@repo/strapi-types';
import { useTranslations } from 'next-intl';
import AppLink from '@/components/elementary/AppLink';
import { Tag } from '@/components/elementary/Tag';
import { BasicImage } from '@/components/page-builder/components/BasicImage';
import { Paragraph } from '@/components/typography/Paragraph';
import { cn } from '@/lib/styles';
import styles from './NavbarMenuLink.module.css';
interface NavbarMenuLinkProps {
  readonly link: Data.Component<'layout-utilities.navbar-links'>;
  readonly isDropDownItem?: boolean;
  readonly stackIcon?: boolean;
  readonly testId?: string;
  onClick?: () => void;
}
export function NavbarMenuLink(t0) {
  const $ = _c(34);
  const {
    link,
    isDropDownItem: t1,
    stackIcon: t2,
    testId,
    onClick
  } = t0;
  const isDropDownItem = t1 === undefined ? false : t1;
  const stackIcon = t2 === undefined ? false : t2;
  const t = useTranslations("Navbar");
  const shouldStackIcon = stackIcon && link.icon;
  const t3 = link.href ?? "";
  const t4 = link.id;
  const t5 = !!link.newTab;
  const t6 = shouldStackIcon && "lg:flex-col lg:items-start";
  let t7;
  if ($[0] !== t6) {
    t7 = cn("flex gap-2 w-fit flex-row items-center", t6);
    $[0] = t6;
    $[1] = t7;
  } else {
    t7 = $[1];
  }
  let t8;
  if ($[2] !== link.hasPeachIconBackground || $[3] !== link.icon) {
    t8 = link.icon && <div className={cn("flex justify-center shrink-0 size-8 items-center p-1.25 border border-neutral-light-400 rounded", link.hasPeachIconBackground ? "bg-peach-200" : "bg-transparent")}><div className="relative size-6 shrink-0"><BasicImage component={link?.icon} className="object-contain" fill={true} ignoreMediaSize={true} /></div></div>;
    $[2] = link.hasPeachIconBackground;
    $[3] = link.icon;
    $[4] = t8;
  } else {
    t8 = $[4];
  }
  const t9 = isDropDownItem ? "flex-col" : "gap-1.5";
  let t10;
  if ($[5] !== t9) {
    t10 = cn("flex", t9);
    $[5] = t9;
    $[6] = t10;
  } else {
    t10 = $[6];
  }
  let t11;
  if ($[7] !== isDropDownItem || $[8] !== link.newTag || $[9] !== link.title || $[10] !== t) {
    t11 = link?.title && <Paragraph fontSize="bodyRegularMedium" className={cn("text-inherit", isDropDownItem ? styles["nav-content-dropdown-link"] : styles["nav-content-menu-link"])}>{link.title}{!isDropDownItem && link?.newTag && <Tag name={t("newBadge")} variant="green-success" size="small" className="ml-1.5" />}</Paragraph>;
    $[7] = isDropDownItem;
    $[8] = link.newTag;
    $[9] = link.title;
    $[10] = t;
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  let t12;
  if ($[12] !== isDropDownItem || $[13] !== link.description) {
    t12 = link?.description && !isDropDownItem && <Paragraph className={cn("text-inherit whitespace-nowrap", styles["nav-content-menu-link"])}>{link.description}</Paragraph>;
    $[12] = isDropDownItem;
    $[13] = link.description;
    $[14] = t12;
  } else {
    t12 = $[14];
  }
  let t13;
  if ($[15] !== t10 || $[16] !== t11 || $[17] !== t12) {
    t13 = <div className={t10}>{t11}{t12}</div>;
    $[15] = t10;
    $[16] = t11;
    $[17] = t12;
    $[18] = t13;
  } else {
    t13 = $[18];
  }
  let t14;
  if ($[19] !== t13 || $[20] !== t7 || $[21] !== t8) {
    t14 = <div className={t7}>{t8}{t13}</div>;
    $[19] = t13;
    $[20] = t7;
    $[21] = t8;
    $[22] = t14;
  } else {
    t14 = $[22];
  }
  let t15;
  if ($[23] !== isDropDownItem || $[24] !== link.description) {
    t15 = link?.description && isDropDownItem && <Paragraph fontSize="bodyRegularMedium">{link.description}</Paragraph>;
    $[23] = isDropDownItem;
    $[24] = link.description;
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  let t16;
  if ($[26] !== link.id || $[27] !== onClick || $[28] !== t14 || $[29] !== t15 || $[30] !== t3 || $[31] !== t5 || $[32] !== testId) {
    t16 = <AppLink variant="primaryLink" size="none" href={t3} key={t4} openExternalInNewTab={t5} className="flex flex-col gap-2 w-fit items-start" data-test-id={testId} onClick={onClick}>{t14}{t15}</AppLink>;
    $[26] = link.id;
    $[27] = onClick;
    $[28] = t14;
    $[29] = t15;
    $[30] = t3;
    $[31] = t5;
    $[32] = testId;
    $[33] = t16;
  } else {
    t16 = $[33];
  }
  return t16;
}